import React from 'react'
import { Toolbar, SaveButton } from 'react-admin'

const FormToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
)

export default FormToolbar
